/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Template16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M13.5 2a1.5 1.5 0 011.493 1.356L15 3.5v9a1.5 1.5 0 01-1.356 1.493L13.5 14h-11a1.5 1.5 0 01-1.493-1.356L1 12.5v-9a1.5 1.5 0 011.356-1.493L2.5 2h11zM10 6H2v6.5a.5.5 0 00.41.492L2.5 13H10V6zm4 0h-3v7h2.5a.5.5 0 00.492-.41L14 12.5V6zm-.5-3h-11a.5.5 0 00-.492.41L2 3.5V5h12V3.5a.5.5 0 00-.41-.492L13.5 3z"
        />
    </AccessibleSVG>
);

export default Template16;
